define.alias("shared/components/shared/post/secondary/hashtag-suggestions/wrapper", "settings/components/shared/post/secondary/hashtag-suggestions/wrapper");